import { render } from "./PartTextFiles.vue?vue&type=template&id=43de8ea4&scoped=true"
import script from "./PartTextFiles.vue?vue&type=script&lang=js"
export * from "./PartTextFiles.vue?vue&type=script&lang=js"

import "./PartTextFiles.vue?vue&type=style&index=0&id=43de8ea4&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43de8ea4"]])

export default __exports__